import { useLayoutEffect, useRef } from 'react';
import useRefManager from './useRefManager';

function useColumnWidths(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      loading = _ref.loading,
      bodyRef = _ref.bodyRef;

  var _useRefManager = useRefManager(),
      columnRefs = _useRefManager[0],
      getColumnRef = _useRefManager[1];

  var columnWidths = useRef([]);
  useLayoutEffect(function () {
    var nextColumnWidths = [];
    var cells = [];
    var paddingDelta = 0; // build cells collection

    for (var key in columnRefs.current) {
      var _key$split = key.split('.'),
          columnIndex = _key$split[0],
          rowIndex = _key$split[1],
          parentRowIndex = _key$split[2];

      var column = columns[columnIndex];
      var node = columnRefs.current[key];
      var isSubColumn = parentRowIndex !== undefined; // skip sub columns unless specifically enabled

      if (!column.includeSubCellWidth && isSubColumn) {
        continue;
      } // this is a naive padding calculation, but getComputedStyle is expensive
      // and all cells should use the same padding so it should be ok
      // alternatively, we could use a first-class padding API to avoid getComputedStyle


      if (!paddingDelta) {
        var computedStyle = getComputedStyle(node);
        paddingDelta = parseInt(computedStyle.paddingLeft, 10) + parseInt(computedStyle.paddingRight, 10);
      } // only collect widths for undefined column.width


      if (column.width) {
        node.style.width = column.width + 'px';

        if (!nextColumnWidths[columnIndex]) {
          nextColumnWidths[columnIndex] = column.width;
        }
      } else {
        // set cell widths to "auto" so we can take an accurate measurement
        node.style.width = 'auto'; // store cell data so it's easier to work with below

        cells.push({
          column: column,
          columnIndex: columnIndex,
          node: node
        });
      }
    } // collect the largest width from the header and body cells


    for (var index = 0; index < cells.length; index++) {
      var _cells$index = cells[index],
          _column = _cells$index.column,
          _columnIndex = _cells$index.columnIndex,
          _node = _cells$index.node;
      var width = Math.max(Math.ceil(_node.getBoundingClientRect().width) - paddingDelta, nextColumnWidths[_columnIndex] || 0);

      if (_column.minWidth) {
        width = Math.max(width, _column.minWidth);
      }

      if (_column.maxWidth) {
        width = Math.min(width, _column.maxWidth);
      }

      nextColumnWidths[_columnIndex] = width;
    } // apply widths back to cells


    for (var _index = 0; _index < cells.length; _index++) {
      var _cells$_index = cells[_index],
          _columnIndex2 = _cells$_index.columnIndex,
          _node2 = _cells$_index.node;
      _node2.style.width = nextColumnWidths[_columnIndex2] + 'px';
    } // apply row widths


    var minRowWidth = bodyRef.current.scrollWidth;

    for (var _index2 = 0; _index2 < bodyRef.current.children.length; _index2++) {
      bodyRef.current.children[_index2].style.minWidth = minRowWidth + 'px';
    } // update column widths for sub rows


    columnWidths.current = nextColumnWidths;
  }, [columns, data, loading]);
  return {
    columnWidths: columnWidths,
    getColumnRef: getColumnRef
  };
}

export default useColumnWidths;